module.exports = __webpack_public_path__ + "img/blogs_plum_purple.fb7ee95e.png";